module.exports = "/_next/static/images/1494547b3c7ffb4d6e1d890ed0e35d06-mastercard-left-lg.jpg.webp";